"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiSelectField = MultiSelectField;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const ComboBoxBase_1 = require("./internal/ComboBoxBase");
function MultiSelectField(props) {
    const { getOptionValue = (opt) => opt.id, // if unset, assume O implements HasId
    getOptionLabel = (opt) => opt.name, // if unset, assume O implements HasName
    ...otherProps } = props;
    return (0, jsx_runtime_1.jsx)(ComboBoxBase_1.ComboBoxBase, { multiselect: true, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, ...otherProps });
}
